import { styled } from "styled-components";
import leftTail from '../../assets/left_grey_tail.svg';

const Wrapper = styled.div`
  position: relative;
  width: 80%;
  padding: 10px 13px;
  border-radius: 20px;
  background: var(--Light-F5, #F5F5F5);
  margin-bottom: 30px;
  p {
    padding: 0px;
    margin: 0px;
    padding-left: 10px;    
  }
  &::before {
    content: '';
    position: absolute;
    bottom: -12px;
    left: -7px;
    width: 30px;
    height: 30px;
    background-image: url(${leftTail});
    background-repeat: no-repeat;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const QuestionText = ({ message, form }) => {
  return (
    <Wrapper className='qPart'>
      <p>{message}</p>
      {form ? form : false}
    </Wrapper>
  );
};

export default QuestionText;
